import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetrimbkeshwarcab() {



    const cardData = {

keyword: "Pune to Trimbakeshwar Cab",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Pune to Trimbakeshwar Cab services for pilgrims, families, and spiritual travelers visiting one of the twelve Jyotirlingas of Lord Shiva. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles with experienced long-route drivers for a safe and smooth journey. Our service includes flexible one-way and round-trip options, doorstep pickup from Pune, transparent pricing, and 24/7 booking support. Rising Cab Service ensures a peaceful and hassle-free pilgrimage experience to Trimbakeshwar.",

topPlaces: [
    {
        title: "Trimbakeshwar Jyotirlinga Temple",
        description:
            "Trimbakeshwar Jyotirlinga Temple is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva and is located near Nashik. The temple is famous for its unique three-faced Shiva lingam representing Brahma, Vishnu, and Mahesh. It is a highly revered pilgrimage site attracting devotees from across India."
    },
    {
        title: "Brahmagiri Hill",
        description:
            "Brahmagiri Hill is the origin point of the Godavari River and a popular trekking destination near Trimbakeshwar. It offers scenic views, spiritual significance, and a challenging yet rewarding climb for devotees and trekkers."
    },
    {
        title: "Anjaneri Hills",
        description:
            "Anjaneri Hills is believed to be the birthplace of Lord Hanuman and is a major trekking and spiritual site near Trimbakeshwar. The location offers beautiful landscapes, caves, and religious importance."
    },
    {
        title: "Gangadwar",
        description:
            "Gangadwar is a sacred spot on Brahmagiri Hill where the Godavari River is believed to emerge. It is an important pilgrimage site for devotees performing rituals and prayers."
    },
    {
        title: "Kushavarta Kund",
        description:
            "Kushavarta Kund is a holy water tank near Trimbakeshwar Temple where devotees take a sacred bath before visiting the Jyotirlinga. It holds great religious importance in Hindu rituals."
    },
    {
        title: "Nashik Panchvati",
        description:
            "Panchvati in Nashik is a spiritually significant area associated with Lord Rama’s exile. It includes temples like Kalaram Temple, Sita Gufa, and sacred ghats along the Godavari River."
    },
    {
        title: "Sula Vineyards",
        description:
            "Sula Vineyards is one of India’s most famous wineries near Nashik, offering wine tasting tours, scenic vineyard views, and a relaxing leisure experience for travelers."
    },
    {
        title: "Saptashrungi Devi Temple",
        description:
            "Saptashrungi Devi Temple is a powerful Shakti Peeth located in the Sahyadri hills near Nashik. The temple is situated on a steep hill and offers stunning views and spiritual significance."
    },
    {
        title: "Pandavleni Caves",
        description:
            "Pandavleni Caves are ancient rock-cut Buddhist caves located near Nashik. They feature inscriptions, sculptures, and a peaceful hilltop environment ideal for history lovers and tourists."
    },
    {
        title: "Dudhsagar Falls Nashik Region",
        description:
            "Dudhsagar-style seasonal waterfalls near Nashik become highly scenic during monsoon, attracting nature lovers and photographers visiting the Trimbakeshwar region."
    }
],



services: [
    {
        name: "Pune to Trimbakeshwar Cab",
        description:
            "Rising Cab Service offers Pune to Trimbakeshwar Cab for safe, comfortable, and reliable intercity travel to the sacred Trimbakeshwar Jyotirlinga temple. We provide well-maintained AC vehicles, experienced drivers, and 24x7 booking support for family trips, pilgrimages, and group travel. Our service ensures smooth highway rides, timely pickup, and affordable pricing for a stress-free journey from Pune to Trimbakeshwar."
    },
    {
        name: "Pune to Trimbakeshwar Taxi Service",
        description:
            "Our Pune to Trimbakeshwar Taxi Service ensures convenient and safe travel for devotees and tourists visiting the holy Jyotirlinga temple. Rising Cab Service offers professional drivers, clean vehicles, and flexible booking options including one-way and round-trip journeys with complete comfort and reliability."
    },
    {
        name: "Pune to Trimbakeshwar Cab Booking",
        description:
            "Book Pune to Trimbakeshwar Cab Booking with Rising Cab Service for instant confirmation, easy scheduling, and multiple vehicle options. We ensure hassle-free booking, transparent pricing, and smooth travel experience for all passengers traveling to Trimbakeshwar from Pune."
    },
    {
        name: "Pune to Trimbakeshwar One Way Cab",
        description:
            "Rising Cab Service provides Pune to Trimbakeshwar One Way Cab for travelers who need a direct drop service without return charges. Enjoy affordable pricing, safe driving, and comfortable vehicles for a smooth journey to Trimbakeshwar."
    },
    {
        name: "Pune to Trimbakeshwar Round Trip Cab",
        description:
            "Our Pune to Trimbakeshwar Round Trip Cab is ideal for same-day or multi-day return travel plans. We offer flexible waiting options, experienced chauffeurs, and comfortable vehicles for a complete pilgrimage experience."
    },
    {
        name: "Pune to Trimbakeshwar Darshan Cab",
        description:
            "Rising Cab Service provides Pune to Trimbakeshwar Darshan Cab for devotees planning temple visits with smooth travel arrangements, punctual service, and comfortable rides designed for spiritual journeys."
    },
    {
        name: "Pune to Trimbakeshwar Jyotirlinga Cab",
        description:
            "Book Pune to Trimbakeshwar Jyotirlinga Cab for a sacred pilgrimage to one of the 12 Jyotirlingas in India. We ensure safe travel, experienced drivers familiar with temple routes, and peaceful journey experience for families and devotees."
    },
    {
        name: "Pune to Trimbakeshwar Temple Cab",
        description:
            "Rising Cab Service offers Pune to Trimbakeshwar Temple Cab for convenient temple visits with reliable pickup, comfortable seating, and professional drivers ensuring a smooth spiritual travel experience."
    },
    {
        name: "Pune to Trimbakeshwar Taxi Fare",
        description:
            "Get transparent Pune to Trimbakeshwar Taxi Fare with Rising Cab Service. We offer affordable pricing based on vehicle type and trip plan, ensuring no hidden charges and complete clarity for all passengers."
    },
    {
        name: "Pune to Trimbakeshwar Car Rental",
        description:
            "Our Pune to Trimbakeshwar Car Rental service provides a variety of vehicles including hatchbacks, sedans, SUVs, and Innova Crysta for comfortable intercity travel with professional drivers and flexible booking options."
    },
    {
        name: "Pune to Trimbakeshwar Outstation Cab",
        description:
            "Rising Cab Service offers Pune to Trimbakeshwar Outstation Cab for long-distance travel with safe driving, well-maintained vehicles, and reliable service ensuring comfort throughout the journey."
    },
    {
        name: "Pune to Trimbakeshwar Tour Package",
        description:
            "Book Pune to Trimbakeshwar Tour Package with Rising Cab Service for a complete pilgrimage experience including cab travel, flexible timings, and comfortable journey arrangements for families and groups."
    },
    {
        name: "Pune to Trimbakeshwar Online Cab Booking",
        description:
            "Our Pune to Trimbakeshwar Online Cab Booking system allows quick reservations with instant confirmation, multiple vehicle choices, and transparent pricing for a smooth booking experience."
    },
    {
        name: "Pune to Trimbakeshwar Same Day Return Cab",
        description:
            "Rising Cab Service provides Pune to Trimbakeshwar Same Day Return Cab for quick pilgrimage trips with flexible waiting time, safe travel, and comfortable vehicles for hassle-free return journeys."
    },
    {
        name: "Pune to Trimbakeshwar Family Cab Service",
        description:
            "Our Pune to Trimbakeshwar Family Cab Service ensures safe and comfortable travel for families with spacious vehicles, professional drivers, and smooth journey experience to the temple."
    },
    {
        name: "Pune to Trimbakeshwar SUV Cab Booking",
        description:
            "Book Pune to Trimbakeshwar SUV Cab Booking for spacious and comfortable group travel with SUVs like Innova and Ertiga, ideal for long journeys and family pilgrimages."
    },
    {
        name: "Pune to Trimbakeshwar Taxi",
        description:
            "Rising Cab Service offers Pune to Trimbakeshwar Taxi for reliable and safe travel with professional drivers and clean vehicles ensuring a comfortable pilgrimage journey."
    },
    {
        name: "Trimbakeshwar to Pune Cab",
        description:
            "We also provide Trimbakeshwar to Pune Cab for return travel with safe pickups, comfortable rides, and experienced drivers ensuring a smooth journey back to Pune."
    }
],

tableData: [
    ["Pune to Trimbakeshwar Cab", "Pune to Trimbakeshwar Taxi Service"],
    ["Pune to Trimbakeshwar Cab Booking", "Pune to Trimbakeshwar One Way Cab"],
    ["Pune to Trimbakeshwar Round Trip Cab", "Pune to Trimbakeshwar Darshan Cab"],
    ["Pune to Trimbakeshwar Jyotirlinga Cab", "Pune to Trimbakeshwar Temple Cab"],
    ["Pune to Trimbakeshwar Taxi Fare", "Pune to Trimbakeshwar Car Rental"],
    ["Pune to Trimbakeshwar Outstation Cab", "Pune to Trimbakeshwar Tour Package"],
    ["Pune to Trimbakeshwar Online Cab Booking", "Pune to Trimbakeshwar Same Day Return Cab"],
    ["Pune to Trimbakeshwar Family Cab Service", "Pune to Trimbakeshwar SUV Cab Booking"],
    ["Pune to Trimbakeshwar Taxi", "Trimbakeshwar to Pune Cab"]
],





whychoose: [
    {
        WhyChooseheading: "Convenient Pune to Trimbakeshwar Travel Solutions",
        WhyChoosedescription: "Rising Cab Service offers dedicated Pune to Trimbakeshwar cab services for devotees, pilgrims, families, and tourists seeking a comfortable journey to one of the twelve Jyotirlingas."
    },
    {
        WhyChooseheading: "Ideal for Religious and Spiritual Tours",
        WhyChoosedescription: "Our cab service is a preferred choice for devotees visiting Trimbakeshwar Temple, Kushavarta Kund, Brahmagiri Hills, and nearby sacred destinations."
    },
    {
        WhyChooseheading: "Travel in Comfort with Modern Vehicles",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and other vehicles designed to provide a pleasant long-distance travel experience."
    },
    {
        WhyChooseheading: "Flexible Darshan and Sightseeing Plans",
        WhyChoosedescription: "Customers can plan same-day visits, overnight trips, or customized pilgrimage tours according to their schedule and travel preferences."
    },
    {
        WhyChooseheading: "Hassle-Free Pickup from Pune Locations",
        WhyChoosedescription: "Pickup services are available from homes, hotels, Pune Airport, Railway Station, Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, and all major Pune areas."
    },
    {
        WhyChooseheading: "Professional Drivers Familiar with Pilgrimage Routes",
        WhyChoosedescription: "Our experienced drivers regularly operate on the Trimbakeshwar route and ensure safe, efficient, and comfortable transportation."
    },
    {
        WhyChooseheading: "Suitable for Solo Travelers and Large Groups",
        WhyChoosedescription: "Whether traveling alone, with family, or in a religious group, we provide vehicle options suitable for every type of traveler."
    },
    {
        WhyChooseheading: "Value-Packed Cab Packages",
        WhyChoosedescription: "Rising Cab Service delivers affordable Pune to Trimbakeshwar cab packages with transparent pricing and dependable travel arrangements."
    }
]
};

const faqData = [
    {
        question: "What makes Trimbakeshwar one of the most visited pilgrimage destinations?",
        answer: "Trimbakeshwar is one of the twelve sacred Jyotirlingas of Lord Shiva and attracts devotees from across India throughout the year."
    },
    {
        question: "Approximately how far is Trimbakeshwar from Pune?",
        answer: "The distance is approximately 240 to 260 kilometers depending on the chosen route and pickup location."
    },
    {
        question: "Can pilgrims complete darshan and return to Pune on the same day?",
        answer: "Yes, same-day return trips are available for travelers who prefer a short pilgrimage itinerary."
    },
    {
        question: "Which vehicle is commonly selected for family temple visits?",
        answer: "Many families prefer Ertiga and Innova Crysta due to their spacious seating and travel comfort."
    },
    {
        question: "Are larger vehicles available for religious groups?",
        answer: "Yes, Tempo Travellers and group transportation vehicles can be arranged for pilgrim groups and family gatherings."
    },
    {
        question: "Can nearby attractions be included in the travel plan?",
        answer: "Yes, destinations such as Nashik, Panchavati, Sula Vineyards, and other attractions can be added to customized itineraries."
    },
    {
        question: "During which periods is advance reservation recommended?",
        answer: "Advance booking is advisable during Shravan month, Mahashivratri, weekends, and major festival periods."
    },
    {
        question: "What facilities can travelers expect inside the vehicle?",
        answer: "Passengers can enjoy clean interiors, air-conditioned comfort, comfortable seating, and professional driver assistance."
    },
    {
        question: "Do senior citizens frequently use this pilgrimage service?",
        answer: "Yes, many senior citizens choose this service because of the convenience of door-to-door transportation."
    },
    {
        question: "How can travelers secure a Pune to Trimbakeshwar cab booking?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp inquiries, or online reservations with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vinayak Deshmukh",
        feedback:
            "The pilgrimage to Trimbakeshwar was arranged perfectly. The journey was comfortable, the vehicle was in excellent condition, and every part of the trip was managed professionally.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Manisha Jagtap",
        feedback:
            "Traveling with elderly family members was completely stress-free. The driver was patient and courteous, and the overall experience exceeded our expectations.",
        rating: 5
    }
];











    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Trimbakeshwar Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-trimbakeshwar-cab.jpg",
"description": "Book Pune to Trimbakeshwar Cab Service with Rising Cab Service for comfortable temple visits and outstation travel. Enjoy safe, affordable, and reliable taxi service for one-way, round-trip, and pilgrimage trips to Trimbakeshwar Jyotirlinga.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-trimbakeshwar-cab"
}
};







    return (
        <div>

<Helmet>
  <title>Pune to Trimbakeshwar Cab Service | Jyotirlinga Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Trimbakeshwar Cab Service for Jyotirlinga temple visit. Affordable AC taxi service for one-way, round-trip, and pilgrimage travel with professional drivers from Pune to Trimbakeshwar."
/>

<meta
 name="keywords"
 content="Pune to trimbakeshwar cab fare, Pune to trimbakeshwar car rental, Pune to trimbakeshwar taxi, Pune to trimbakeshwar taxi fare, Trimbakeshwar to pune cab, Pune to Trimbakeshwar Cab, Pune to Trimbakeshwar Taxi Service, Pune to Trimbakeshwar Cab Booking, Pune to Trimbakeshwar One Way Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/23.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetrimbkeshwarcab;